import React, { useContext, useEffect, useState } from 'react';
import styled from "styled-components";
import { AppContext } from '../../contexts/AppContext';
import moment from 'moment';
import useInterval from '../../helpers/useInterval';
import { useHistory } from 'react-router';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { SettingsApplications } from '@material-ui/icons';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const Wrapper = styled.div`
background-color: ${props => props.colorTheme.backgroundColor};
display:  flex;
flex-direction: row;
overflow-x: hidden;
overflow-y: hidden;
width: 100%;
margin-left: 0px;
margin-right: 0px;
height: 60px;
`;

const Section = styled.div`
overflow-x: hidden;
overflow-y: hidden;
flex: 4;
border-width: 1px !important;
border-bottom: solid;
border-color: ${props => props.colorTheme.header.borderColor};
text-align: center;
`;

const SettingsSection = styled.div`
overflow-x: hidden;
overflow-y: hidden;
flex: 1;
border-width: 1px !important;
border-bottom: solid;
border-left: solid;
border-color: ${props => props.colorTheme.header.borderColor};
text-align: center;
`;

const DateSection = styled.div`
overflow-x: hidden;
overflow-y: hidden;
flex: 3;
border-width: 1px !important;
border-bottom: solid;
border-color: ${props => props.colorTheme.header.borderColor};
text-align: center;
display: flex;
`;

const LogoSection = styled.div`
overflow-x: hidden;
overflow-y: hidden;
flex: 10;
border-width: 1px !important;
border-right: solid;
border-left: solid;
border-bottom: solid;
border-color: ${props => props.colorTheme.header.borderColor};
text-align: center;
`;

const Title = styled.p`
margin-top: 19px;
font-size: 20px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
color: ${props => props.colorTheme.header.fontColor};
font-family: DINNextLTPro-Regular;
`;

const Date = styled.div`
margin-top: 19px;
font-size: 16px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
color: ${props => props.colorTheme.header.fontColor};
flex: 2;
text-align: center;
`;

const Settings = styled.div`
margin-top: 19px;
font-size: 16px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
color: ${props => props.colorTheme.header.fontColor};
flex: 1;
text-align: center;
`;


const Logo = styled.img`
src: "${props => props.src}";
width: 100px;
margin-top: 15px;
margin-bottom: 15px;
`;

const IconDiv = styled.div`
display: inline;
margin-right: 5px;
`;

export function Header() {

    const { kitchen, loggedIn, setLoggedIn, currentTheme, setSettingsOpen } = useContext(AppContext);
    const [time, setTime] = useState();
    const [date, setDate] = useState();
    const history = useHistory();

    useInterval(() => {
        setTime(moment().format('HH:mm'));
        setDate(moment().format('MM/DD/YYYY'));
    }, 1000);

    const onLogoClick = () => {
        setLoggedIn(false);
        history.replace("/kitchenselect");
    }

    const onSettingsClick = () => {
        setSettingsOpen(true);
    }

    return (
        <div>
            <Wrapper colorTheme={currentTheme.dashboard}>
                <Section colorTheme={currentTheme.dashboard}>
                    <Title colorTheme={currentTheme.dashboard}>
                        {kitchen.name}
                    </Title>
                </Section>
                <LogoSection colorTheme={currentTheme.dashboard} onClick={onLogoClick}>
                    <Logo src={currentTheme.dashboard.header.logoImage.default} />
                </LogoSection>
                <DateSection colorTheme={currentTheme.dashboard}>
                    <Date colorTheme={currentTheme.dashboard}>
                        <IconDiv>
                            <CalendarTodayIcon style={{ fontSize: '15px' }} />
                        </IconDiv>
                        {date || moment().format('MM/DD/YYYY')}
                    </Date>
                    <Date colorTheme={currentTheme.dashboard}>
                        <IconDiv>
                            <AccessTimeIcon style={{ fontSize: '15px' }} />
                        </IconDiv>
                        {time || moment().format('HH:mm')}
                    </Date>
                </DateSection>
                <SettingsSection colorTheme={currentTheme.dashboard}>
                    <Settings colorTheme={currentTheme.dashboard}>
                        <IconDiv>
                            <MoreVertIcon onClick={onSettingsClick} style={{ fontSize: '25px' }} />
                        </IconDiv>
                    </Settings>
                </SettingsSection>
            </Wrapper>
        </div>
    );
}